import { Col } from "antd";
import { Form, Input, Row } from "antd";
import React, { FC, useEffect, useState } from "react";

type BillingDetailsProps = {
  form: any;
  isApproved: boolean;
  portalSubmission: any
};

const BillingDetails: FC<BillingDetailsProps> = ({ form, isApproved, portalSubmission }) => {
  const [totalAmount, setTotalAmount] = useState(0);
  const totalFields = [
    "packages",
    "roomRentAndNursingCharge",
    "consultation",
    "otCharge",
    "surgeonAndAnesthetist",
    "investigation",
    "medicineAndConsumables",
    "otherHospitalExpenses",
  ];

  const watchedValues = Form.useWatch([], form);

  useEffect(() => {
    const values = form.getFieldsValue();
    const total = totalFields.reduce((sum, field) => {
      const value = parseFloat(values[field]) || 0;
      return sum + value;
    }, 0);
    setTotalAmount(total);
  }, [watchedValues]);

  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        Billing Details
      </div>
      <Form
        form={form}
        layout="vertical"
        onValuesChange={() => {
          const values = form.getFieldsValue();
          const total = totalFields?.reduce((sum, field) => {
            const value = parseFloat(values[field]) || 0;
            return sum + value;
          }, 0);
          setTotalAmount(total);
          form.setFieldsValue({ totalAmount });
        }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="packages"
              name="packages"
              style={{ color: "#575757" }}
              rules={[
                {
                  pattern: /^\d+$/,
                  message: "Only Numeric values are allowed!",
                },
              ]}
            >
              <Input
                placeholder="Please input packages"
                disabled={portalSubmission}
                style={{ color: "black" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="ROOM & NURSING CHARGE"
              name="roomRentAndNursingCharge"
              style={{ color: "#575757" }}
              rules={[
                {
                  pattern: /^\d+$/,
                  message: "Only Numeric values are allowed!",
                },
              ]}
            >
              <Input
                placeholder="Please input roomRent And Nursing Charges"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="CONSULTATION"
              name="consultation"
              style={{ color: "#575757" }}
              rules={[
                {
                  pattern: /^\d+$/,
                  message: "Only Numeric values are allowed!",
                },
              ]}
            >
              <Input
                placeholder="Please input consultation"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="OT CHARGES"
              name="otCharge"
              style={{ color: "#575757" }}
              rules={[
                {
                  pattern: /^\d+$/,
                  message: "Only Numeric values are allowed!",
                },
              ]}
            >
              <Input
                placeholder="Please input ot Charges"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="SURGEON & ANESTHETIST"
              name="surgeonAndAnesthetist"
              style={{ color: "#575757" }}
              rules={[
                {
                  pattern: /^\d+$/,
                  message: "Only Numeric values are allowed!",
                },
              ]}
            >
              <Input
                placeholder="Please input surgeon And Anesthetist"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="INVESTIGATION"
              name="investigation"
              style={{ color: "#575757" }}
              rules={[
                {
                  pattern: /^\d+$/,
                  message: "Only Numeric values are allowed!",
                },
              ]}
            >
              <Input
                placeholder="Please input investigation"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="MEDICINE & CONSUMABLES"
              name="medicineAndConsumables"
              style={{ color: "#575757" }}
              rules={[
                {
                  pattern: /^\d+$/,
                  message: "Only Numeric values are allowed!",
                },
              ]}
            >
              <Input
                placeholder="Please input MEDICINE & CONSUMABLES"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="OTHER HOSPITAL EXPENSES"
              name="otherHospitalExpenses"
              style={{ color: "#575757" }}
              rules={[
                {
                  pattern: /^\d+$/,
                  message: "Only Numeric values are allowed!",
                },
              ]}
            >
              <Input
                placeholder="Please input OTHER HOSPITAL EXPENSES"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <div>
            <label>Total</label>
            <h3 style={{ marginTop: "0.5rem" }}>₹ {totalAmount} /-</h3>
          </div>
        </Row>
      </Form>
    </div>
  );
};

export default BillingDetails;
